// /* eslint-disable */
import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Tab, Tabs, Typography, useTheme } from "@mui/material";
import { activateHotel, authorizedPost, toggleBillingFeature, toggleLoading, updateHotelConnectedRooms, updateHotelDependency, updateHotelRevenueManager, toggleWhatsAppBookingFeature, updatePropertyPackage } from "../../store/actions";
import { useNavigate, useParams } from "react-router-dom";
import { LIST_HOTEL_DETAILS } from "../../graphql";
import { useDispatch } from "react-redux";
import { ArrowBack } from "@mui/icons-material";
import { tokens } from "../../theme";
import HotelPackages from "./hotel-packages";
import HotelLogs from "./hotel-logs";
import Bookings from "./bookings";
import SwitchWithConfirmModal from "../../components/SwitchWithConfirmModal";
import ConfirmDialog from "../../components/ConfirmDialog";

import GoogleMappingSection from "./google-mapping/GoogleMappingSection";

// Mirrors the package enum on the hotels schema. A package added there and not here renders
// out of range and lets a save silently downgrade the property.
const PROPERTY_PACKAGES = ["base", "moksha"];

function HotelDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [hotelDetails, setHotelDetails] = useState({});
    const [tab, setTab] = useState(1);
    const [selectedPackage, setSelectedPackage] = useState("");
    const [packageLoading, setPackageLoading] = useState(false);
    const [confirmingPackage, setConfirmingPackage] = useState(false);

    useEffect(() => {
        document.title = "Hotel details";
        fetchHotelDetails();
        // eslint-disable-next-line
    }, [dispatch, id]);
    // console.log(hotelDetails);

    const fetchHotelDetails = async () => {
        dispatch(toggleLoading(true));
        let response = await authorizedPost(LIST_HOTEL_DETAILS, { id: id });
        if (response?.data) {
            const data = response.data.list_hotel_details.data;
            setHotelDetails(data);
            setSelectedPackage(data?.package || "base");
        }
        dispatch(toggleLoading(false));
    };

    const applyPackageUpdate = async () => {
        setConfirmingPackage(false);
        setPackageLoading(true);
        try {
            const result = await dispatch(updatePropertyPackage({ id, package: selectedPackage }));
            if (result) fetchHotelDetails();
        } finally {
            setPackageLoading(false);
        }
    };

    // Moving on to or off moksha changes who can see guest contact on this property's
    // bookings, so it is confirmed like the staff grant. Other package moves are one click.
    const handlePackageUpdate = () => {
        const current = hotelDetails?.package || "base";
        if (selectedPackage === "moksha" || current === "moksha") {
            setConfirmingPackage(true);
            return;
        }
        applyPackageUpdate();
    };

    const FieldAndValue = ({ field, value }) => (
        <Grid item xs={12} md={6}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Typography width={"30%"}>{field}:</Typography>
                <Typography >{value || "-"}</Typography>
            </Stack>
        </Grid>
    )

    return (
        <Box m="20px" mb={15}>
            <Stack direction={"row"} alignItems={"end"} spacing={1} m="20px 0">
                <Button size="small" variant="outlined" onClick={() => navigate(-1)}>
                    <ArrowBack fontSize="small" />
                </Button>
                <Typography fontWeight="bold" variant="h4" textTransform={"uppercase"} color={colors.greenAccent[500]}>
                    {hotelDetails?.name}
                </Typography>
            </Stack>

            <Box sx={{ borderBottom: 1, mb: 2, borderColor: "divider" }}>
                <Tabs
                    value={tab}
                    onChange={(e, n) => setTab(n)}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab value={1} label="Details" sx={{ fontWeight: "bold" }} />
                    <Tab value={2} label="Bookings" sx={{ fontWeight: "bold" }} />
                    <Tab value={3} label="Hotel Packages" sx={{ fontWeight: "bold" }} />
                    <Tab value={4} label="Hotel Logs" sx={{ fontWeight: "bold" }} />
                    <Tab value={5} label="Google Mapping" sx={{ fontWeight: "bold" }} />
                </Tabs>
            </Box>

            {tab === 1 && (
                <>
                <Box
                    width="100%"
                    p={2}
                    borderRadius={2}
                    backgroundColor={colors.primary[400]}
                >
                    <Grid container spacing={2}>
                        <FieldAndValue field={"Hotel name"} value={hotelDetails?.name} />
                        <FieldAndValue field={"Email"} value={hotelDetails?.email} />
                        <FieldAndValue field={"Mobile"} value={hotelDetails?.mobile} />
                        <FieldAndValue field={"Address"} value={hotelDetails?.address} />
                        <FieldAndValue field={"Type"} value={hotelDetails?.type} />
                        <FieldAndValue field={"Status"} value={hotelDetails?.status} />
                        <Grid item xs={12} md={6}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography width={"30%"}>{"Package"}:</Typography>
                                <FormControl size="small" sx={{ minWidth: 140 }}>
                                    <InputLabel>Package</InputLabel>
                                    <Select
                                        value={selectedPackage}
                                        label="Package"
                                        onChange={(e) => setSelectedPackage(e.target.value)}
                                    >
                                        {PROPERTY_PACKAGES.map((pkg) => (
                                            <MenuItem key={pkg} value={pkg}>
                                                {pkg.charAt(0).toUpperCase() + pkg.slice(1)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="secondary"
                                    onClick={handlePackageUpdate}
                                    disabled={packageLoading || selectedPackage === (hotelDetails?.package || "base")}
                                >
                                    {packageLoading ? <CircularProgress size={18} color="inherit" /> : "Update"}
                                </Button>
                            </Stack>
                        </Grid>
                        {/* <Grid item xs={12} md={12}>
                            <Typography mt={2} variant='h4' color={colors.greenAccent[500]} fontWeight={700}>
                                Bank account details
                            </Typography>
                        </Grid>
                        <FieldAndValue field={"Account holder name"} value={hotelDetails?.bank_details?.acc_holder_name} />
                        <FieldAndValue field={"Account number"} value={hotelDetails?.bank_details?.acc_no} />
                        <FieldAndValue field={"IFSC code"} value={hotelDetails?.bank_details?.ifsc} /> */}
                        <Grid item xs={12} md={12}>
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}/>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography width={"30%"}>{"Dependency"}:</Typography>
                                <SwitchWithConfirmModal
                                    isActive={hotelDetails?.is_dependent || false}
                                    action={async() => {
                                        await dispatch(updateHotelDependency({ id: id }))
                                        fetchHotelDetails();
                                    }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography width={"30%"}>{"Connected rooms"}:</Typography>
                                <SwitchWithConfirmModal
                                    isActive={hotelDetails?.is_connected || false}
                                    action={async() => {
                                        await dispatch(updateHotelConnectedRooms({ id: id }))
                                        fetchHotelDetails();
                                    }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography width={"30%"}>{"Revenue manager"}:</Typography>
                                <SwitchWithConfirmModal
                                    isActive={hotelDetails?.revenue_manager || false}
                                    action={async() => {
                                        await dispatch(updateHotelRevenueManager({ id: id }))
                                        fetchHotelDetails();
                                    }}
                                />
                            </Stack>
                        </Grid>
                         <Grid item xs={12} md={6}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography width={"30%"}>{"Billing feature"}:</Typography>
                                <SwitchWithConfirmModal
                                    isActive={hotelDetails?.billing_enabled || false}
                                    action={async() => {
                                        await dispatch(toggleBillingFeature({ id: id }))
                                        fetchHotelDetails();
                                    }}
                                />
                            </Stack>
                        </Grid>
                         <Grid item xs={12} md={6}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography width={"30%"}>{"WhatsApp Booking Feature"}:</Typography>
                                <SwitchWithConfirmModal
                                    isActive={hotelDetails?.whatsapp_booking_enabled || false}
                                    action={async() => {
                                        await dispatch(toggleWhatsAppBookingFeature({ id: id }))
                                        fetchHotelDetails();
                                    }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography width={"30%"}>{"Activate / deactivate hotel"}:</Typography>
                                <SwitchWithConfirmModal
                                    isActive={hotelDetails?.is_active || false}
                                    action={async() => {
                                        await dispatch(activateHotel({ id: id }))
                                        fetchHotelDetails();
                                    }}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>

                </>
            )}

            {tab === 2 && (
                <Bookings
                    hotelId={id}
                    dispatch={dispatch}
                    colors={colors}
                />
            )}
            {tab === 3 && (
                <HotelPackages
                    hotelId={id}
                    dispatch={dispatch}
                    colors={colors}
                />
            )}
            {tab === 4 && (
                <HotelLogs
                    hotelId={id}
                    dispatch={dispatch}
                    colors={colors}
                />
            )}
            {tab === 5 && (
                <GoogleMappingSection
                    hotelId={id}
                    colors={colors}
                />
            )}
            {/* {tab === 4 && (
                <RoomtypeOtaCount
                    roomtypeId={id}
                    dispatch={dispatch}
                    colors={colors}
                />
            )} */}

            {/* Only for a move on to or off moksha - it changes who sees guest contact here */}
            <ConfirmDialog
                open={confirmingPackage}
                title={selectedPackage === "moksha" ? "Move to the Moksha package?" : "Move off the Moksha package?"}
                confirmLabel={selectedPackage === "moksha" ? "Move to Moksha" : "Move off Moksha"}
                onCancel={() => setConfirmingPackage(false)}
                onConfirm={applyPackageUpdate}
            >
                <strong>{hotelDetails?.name || "This property"}</strong>{" "}
                {selectedPackage === "moksha"
                    ? "will start taking Moksha bookings. Agent and guest contact details on those bookings are hidden from its staff unless they hold Moksha access."
                    : "will stop taking Moksha bookings. Its existing Moksha bookings stay as they are."}
            </ConfirmDialog>
        </Box>
    );
}

export default HotelDetails;
